import type { PillProps } from "@gadgetinc/widgets";
import { Pill as BasePill } from "@gadgetinc/widgets";
import { useStyletron } from "baseui";
import React from "react";

export const Pill = (props: PillProps) => {
  const [css, $theme] = useStyletron();

  return (
    <BasePill
      $color="purple"
      $style={{
        ...$theme.typography.MonoParagraphSmall,
      }}
      {...props}
    />
  );
};
